import React from "react";
import { Button, Typography } from "antd";
import { formatUSD } from "helpers/money-format";
import { CheckoutCharge } from "interfaces/checkout-charge";

export enum FeedbackType {
  Success = 1,
  Error = 2,
}

interface Feedback {
  type: FeedbackType;
  message: string;
  receipt?: string;
}

interface Props {
  feedback?: Feedback;
  checkoutInfo?: CheckoutCharge;
  influencer?: any;
  spotsInformation?: any;
  escrow?: any;
  loading?: boolean;
  onClose: () => void;
  onClickPay: () => void;
}

const PaymentCheckout: React.FC<Props> = ({
  feedback,
  checkoutInfo,
  influencer,
  spotsInformation,
  escrow,
  loading,
  onClose,
  onClickPay,
}) => {
  return (
    <div className="payment">
      {feedback && (
        <div
          className={`feedback ${
            feedback?.type === FeedbackType.Error ? "error" : "success"
          }`}
        >
          {feedback?.type === FeedbackType.Error ? (
            <Typography.Text>
              {feedback?.message} If you have any questions, contact us at{" "}
              <a href="mailto:support@mustard.love">support@mustard.love</a>
            </Typography.Text>
          ) : (
            <Typography.Text>
              {feedback?.message}{" "}
              {feedback?.receipt && (
                <a href={feedback?.receipt} target="_blank" rel="noreferrer">
                  View receipt
                </a>
              )}
            </Typography.Text>
          )}
        </div>
      )}

      <Typography.Text
        className="text-regular"
        style={{ marginBottom: 32, display: "block" }}
      >
        To book this application additional payment is required
      </Typography.Text>

      <ul className="payment-list" style={{ marginBottom: 16, gap: 0 }}>
        {influencer?.selfManagedCompensationEnabled && (
          <li style={{ marginBottom: 0 }}>
            <span>
              Current escrow balance:{" "}
              <b> {formatUSD(escrow?.availableAmount || 0)}</b>
            </span>
          </li>
        )}

        <li>
          <span>
            Spots available: <b> {spotsInformation?.amountRemaining || 0}</b>
          </span>
        </li>
      </ul>

      <ul className="payment-list">
        {(checkoutInfo?.influencerCashComp || 0) > 0 && (
          <li>
            <span>
              <b> {formatUSD(checkoutInfo?.influencerCashComp || 0)}</b> --
              Influencer compensation
            </span>
          </li>
        )}

        {(checkoutInfo?.deducedFromEscrowBalanceAvailable || 0) > 0 && (
          <li>
            <span style={{ color: "green" }}>
              <b>
                -
                {formatUSD(
                  checkoutInfo?.deducedFromEscrowBalanceAvailable || 0
                )}
              </b>{" "}
              -- Escrow balance
            </span>
          </li>
        )}

        {(checkoutInfo?.escrowFee || 0) > 0 && (
          <li>
            <span>
              <b>{formatUSD(checkoutInfo?.escrowFee || 0)} </b>-- Escrow fee
            </span>
          </li>
        )}

        {(checkoutInfo?.additionalSpot || 0) > 0 && (
          <li>
            <span>
              <b> {formatUSD(checkoutInfo?.additionalSpot || 0)}</b> -- Spot
              credit
            </span>
          </li>
        )}
      </ul>

      <div className="total">
        <span>Total:</span>
        <b>{formatUSD(checkoutInfo?.totalCharge || 0)}</b>
      </div>
      <div className="footer">
        <Button onClick={onClose}>Cancel</Button>
        <Button
          type="primary"
          loading={loading}
          onClick={onClickPay}
          disabled={loading}
        >
          Pay
        </Button>
      </div>
    </div>
  );
};

export default PaymentCheckout;
